import { ApiService } from '@b2b/common/services/api/types';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ContentHeaderProps, TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';

TemplatesCreateFlexpayCreateController.$inject = [
  '$scope',
  '$state',
  '$uibModal',
  '$timeout',
  '$filter',
  'ApiService',
  'EventTemplateData',
  'TemplatesService',
  'HelpersService',
  'CalendarService',
  'ValidateService',
  'ThemesHelperService',
];

function TemplatesCreateFlexpayCreateController(
  $scope: IScope & { templatesCreateFlexpayCreate: TODO },
  $state: StateService,
  $uibModal: UIBModalService,
  $timeout: ITimeoutService,
  $filter: IFilterService,
  ApiService: ApiService,
  EventTemplateData: TODO,
  TemplatesService: TODO,
  HelpersService: TODO,
  CalendarService: TODO,
  ValidateService: TODO,
  ThemesHelperService: ThemesHelperService
) {
  const ctrl = {
    model: {} as TODO,
    template: {} as TODO,

    isSaving: false,
    isUpdate: false,

    lastUpdated: '',
    lastPublished: '',

    mode: 'create',
    cap: HelpersService.cap,

    company: ThemesHelperService.getCompany(),
    emailSetting: 'always',

    init: function () {
      if ($state.params && $state.params.scheduleId) {
        ctrl.mode = 'edit';
      }

      if (EventTemplateData.data && EventTemplateData.data.success) {
        ctrl.success.init(EventTemplateData);
      } else {
        ctrl.error.init(EventTemplateData);
      }

      ValidateService.clearFieldTests();

      $scope.$emit('Application::contentTitleChange', {
        title: ctrl.cap(ctrl.mode) + ' Flex Pay Schedule',
        buttonLeft: {
          label: 'Close',
          action: () => {
            ctrl.cancel();
          },
        },
        buttonRight: {
          label: ctrl.isMode('edit') ? 'Save' : 'Create & Continue',
          action: () => {
            if (ctrl.isMode('create')) {
              ctrl.save('schedule', true);
            } else {
              ctrl.save(false, true);
            }
          },
        },
      } satisfies ContentHeaderProps);

      ctrl.getNotificationPreference();

      $scope.$on('TemplatesCreateSchedulesCreateController::Error', ctrl.onError);

      console.log('TemplatesCreateSchedulesCreateController::init');
    },

    getNotificationPreference: function () {
      if (ctrl.company && ctrl.company.notificationPreference) {
        ctrl.emailSetting = ctrl.company.notificationPreference;
      }
    },

    isMode: function (mode) {
      return ctrl.mode === mode;
    },

    isReviewState: function (state) {
      return TemplatesService.getReviewState() === state;
    },

    isState: function (state) {
      if ($state.params && $state.params.scheduleId) {
        return $state.current.name?.indexOf('application.templates.edit.flexpay.edit.' + state) === 0;
      }

      return $state.current.name?.indexOf('application.templates.edit.flexpay.create.' + state) === 0;
    },

    getState: function (name) {
      if ($state.params && $state.params.scheduleId) {
        return (
          'application.templates.edit.flexpay.edit.' + name + '({ scheduleId: "' + $state.params.scheduleId + '" })'
        );
      }

      return 'application.templates.edit.flexpay.create.' + name;
    },

    cancel: function () {
      TemplatesService.removeNewSchedule();
      $state.go('application.templates.edit.flexpay');
    },

    remove: function () {
      $uibModal
        .open({
          templateUrl: 'views/application/views/templates/create/schedules/modals/removeSchedule.tpl.html',
          size: 'md',
          controller: 'TemplatesCreateSchedulesRemoveModalController',
          resolve: {
            currentSchedule: () => ctrl.model,
            SoldQuantity: () => ctrl.model.soldQuantity,
            emailSetting: () => ctrl.emailSetting,
          },
        })
        .result.then(() => {
          ApiService.program.flexpay
            .remove({ eventTemplateId: ctrl.template.id, id: ctrl.model.id })
            .then((response) => ctrl.success.remove(response))
            .catch((response) => ctrl.error.remove(response));
        })
        .catch(() => {
          // noop
        });
    },

    save: function (stateName, update) {
      ctrl.isSaving = true;
      ctrl.isUpdate = update;

      $scope.$broadcast('TemplatesCreateSchedulesCreateController::Save');

      ValidateService.runFieldTests();

      // next tick
      $timeout(function () {
        if (ValidateService.errors.length === 0) {
          if ($state.params.scheduleId) {
            ctrl.update(stateName);
          } else {
            ctrl.create(stateName);
          }
        } else {
          ctrl.isSaving = false;
        }
      }, 0);
    },

    prepare: function (schedule) {
      schedule.eventTemplateId = $state.params.id;
      schedule.name = ctrl.model.name;

      return schedule;
    },

    update: function (stateName) {
      ApiService.program.flexpay
        .update(ctrl.prepare(TemplatesService.flexpay.getScheduleById($state.params.scheduleId).schedule))
        .then((response) => {
          ctrl.isSaving = false;

          if (stateName) {
            $state.go('application.templates.edit.flexpay.edit.' + stateName, { scheduleId: response.data.payload.id });
          } else {
            ctrl.success.update(response);
          }
          ctrl.isUpdate = false;
        })
        .catch((response) => ctrl.error.update(response));
    },

    create: function (stateName) {
      ApiService.program.flexpay
        .create(ctrl.prepare(TemplatesService.flexpay.getNewSchedule().schedule))
        .then((response) => {
          ctrl.isSaving = false;

          if (stateName) {
            $state.go('application.templates.edit.flexpay.edit.' + stateName, { scheduleId: response.data.payload.id });
          } else {
            ctrl.success.create(response);
          }
          ctrl.isUpdate = false;
        })
        .catch((response) => ctrl.error.create(response));
    },

    setUpdateTimes: function (template) {
      if (template) {
        if (template.lastUpdated) {
          ctrl.lastUpdated = CalendarService.toFormat(
            CalendarService.parseDate(template.lastUpdated),
            HelpersService.dateFormats.shortDateTime
          );
        }
        if (template.lastPublished) {
          ctrl.lastPublished = CalendarService.toFormat(
            CalendarService.parseDate(template.lastPublished),
            HelpersService.dateFormats.shortDateTime
          );
        }
      }
    },

    success: {
      init: function (response) {
        TemplatesService.setModel(response.data.payload);
        ctrl.template = TemplatesService.getModel();
        ctrl.setUpdateTimes(ctrl.template);

        if ($state.params.scheduleId) {
          ctrl.model = TemplatesService.flexpay.getScheduleById($state.params.scheduleId).schedule;
        } else {
          ctrl.model = TemplatesService.flexpay.getNewSchedule().schedule;
        }
      },
      create: function (response) {
        ctrl.isSaving = false;

        if (!ctrl.isUpdate) {
          $state.go('application.templates.edit.flexpay');
        }
      },
      update: function (response) {
        ctrl.isSaving = false;

        if (!ctrl.isUpdate) {
          $state.go('application.templates.edit.flexpay');
        }
      },
      remove: function (response) {
        $state.go('application.templates.edit.flexpay');
      },
    },

    error: {
      init: function (response) {},
      create: function (response) {
        ctrl.isSaving = false;
        ctrl.error.generic(response);
      },
      update: function (response) {
        ctrl.isSaving = false;
        ctrl.error.generic(response);
      },
      remove: function (response) {
        ctrl.error.generic(response);
      },
      generic: function (response) {
        $scope.$emit('TemplatesCreateSchedulesCreateController::Error', { message: response.data.error });
      },
    },

    onError: function (e, data) {
      if (data.message) {
        $uibModal
          .open({
            templateUrl: 'views/application/views/reports/create/modals/showMessage.tpl.html',
            size: 'md',
            controller: 'ReportsCreateShowMessageModalController',
            resolve: {
              currentTitle: () => 'An error has occurred',
              currentMessage: () => data.message,
              safe: () => true,
            },
          })
          .result.then(() => {
            if (typeof data.callback === 'function') {
              data.callback();
            }
            if (data.state) {
              if (data.stateParams) {
                $state.go(data.state, data.stateParams);
              } else {
                $state.go(data.state);
              }
            }
          })
          .catch(() => {
            // noop
          });
      }
    },
  };

  $scope.templatesCreateFlexpayCreate = ctrl;
  ctrl.init();
}

export const TemplatesCreateFlexpayCreateControllerModule = angular
  .module('acme.view.application.templates.create.flexpay.create.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.templates',
    'acme.common.service.themesHelper',
    'acme.common.service.helpers',
    'acme.common.service.validate',
    'acme.common.service.calendar',
    'acme.common.factory.wizard',
    'acme.view.application.templates.create.schedules.create.removeModal.controllers',
  ])
  .controller('TemplatesCreateFlexpayCreateController', TemplatesCreateFlexpayCreateController).name;
